import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export interface QuoteYieldProps {
  yieldValue?: string;
}

export const QuoteYield: FC<QuoteYieldProps> = ({ yieldValue }) => {
  if (!yieldValue) {
    return null;
  }

  return (
    <div data-e2e="quote-yield">
      <FormattedMessage id="sidePanel.quoteYield.label" />
      {': '}
      {yieldValue}%
    </div>
  );
};
